interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | string)[] = [];
  const push = (p: number | string) => pages.push(p);
  const windowSize = 1;

  push(1);
  if (page - windowSize > 2) push('...');
  for (let p = Math.max(2, page - windowSize); p <= Math.min(totalPages - 1, page + windowSize); p += 1) {
    push(p);
  }
  if (page + windowSize < totalPages - 1) push('...');
  if (totalPages > 1) push(totalPages);

  const btn = 'min-w-9 h-9 px-3 rounded-md text-sm font-medium flex items-center justify-center transition-colors cursor-pointer whitespace-nowrap';

  return (
    <div className="mt-10 flex items-center justify-center gap-2 flex-wrap">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className={`${btn} border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((p, i) =>
        typeof p === 'number' ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${btn} ${p === page ? 'bg-primary-500 text-background-50' : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600'}`}
          >
            {p}
          </button>
        ) : (
          <span key={`dot-${i}`} className="px-1 text-foreground-400">…</span>
        )
      )}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className={`${btn} border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}